export default __webpack_public_path__ + "static/media/3t.49b7f404.jpg";